"use strict";

var _doc = document;
var _win = window;

// Global components
var EB =  EB || {};

var App = function()
{
	function Init()
	{
		// General
		InitHeader();
		DisableOutlines();
		DisableHover();
		ShowCookiePreferences();

		// Components
		InitCarousels();
		InitSliders();
		InitVideoModals();
		InitForms();
		InitSelects();
		InitSavingsCalculator();
		InitSubnav();

		// Home
		InitHeroPowerUp();
		InitFeatureSlides();
		InitUpdateTabs();

		// Products
		InitAvitiFaqs();
		InitVideoPlayOnHover();

		// Resources
		InitResourceSearch();
		InitResourceLayoutToggles();
		InitResourceLinkPreviews();

		// Company
		InitTimelineSlider();
		InitTestimonials();
		InitOpeningFilters();
	}

	// General

	function Breakpoint()
	{
		return parseFloat(
			getComputedStyle(_doc.documentElement, null)
				.getPropertyValue('font-family')
				.replace(/[^0-9.]+/g, '')
		);
	}

	function DisableOutlines()
	{
		var outlineClass = '-no-outline';
		var el = null;

		var fn = {
			delegate: function(e) {
				el = e.target;

				while (el && el.tagName !== 'A') {
					el = el.parentNode;
				}

				if (el) {
					el.addEventListener('blur', fn.blur);
					el.classList.add(outlineClass);
				}
			},
			blur: function() {
				el.removeEventListener('blur', fn.blur);
				el.classList.remove(outlineClass)
			}
		};

		_doc.addEventListener('click', fn.delegate);
	}

	function DisableHover()
	{
		var html = _doc.documentElement;
		var clickClass = '-click';
		var touchClass = '-touch';

		var fn = {
			toggle: function() {
				if (
					('ontouchstart' in _win) ||
					(navigator.maxTouchPoints > 0) ||
					(navigator.msMaxTouchPoints > 0)
				) {
					html.classList.remove(clickClass);
					html.classList.add(touchClass);
				} else {
					html.classList.remove(touchClass);
					html.classList.add(clickClass);
				}
			}
		};

		_doc.addEventListener('click', fn.toggle);

		fn.toggle();
	}

	function ShowCookiePreferences()
	{
		var $link = _doc.querySelectorAll('[data-ref="osano-cookie-preferences"]');

		// If there's no testimonials to control, return
		if (! $link.length || typeof _win.Osano == 'undefined') {
			return;
		}

		var handle = {
			click: function(e) {
				_win.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');

				e.preventDefault();
			}
		};

		$link[0].addEventListener('click', handle.click);
	}

	// Components

	function InitTestimonials()
	{
		var els = _doc.querySelectorAll('[data-ref="testimonial"]');

		// If there's no testimonials to control, return
		if (! els.length) {
			return;
		}

		var prev = _doc.querySelectorAll('[data-ref="testimonial-prev"]');
		var next = _doc.querySelectorAll('[data-ref="testimonial-next"]');
		var visibleClass = '-is-visible';
		var activeIndex = 0;

		var fn = {
			// Show the previous testimonial
			prev: function() {
				// Remove the currently active testimonials active class
				els[activeIndex].classList.remove(visibleClass);

				// If the current index is the first jump to 
				// the last or show the previous index
				if (activeIndex === 0) {
					activeIndex = els.length - 1;
				} else {
					activeIndex--;
				}

				// Add the active class to the prev index
				els[activeIndex].classList.add(visibleClass);

				// Update the count
				fn.count(activeIndex);
			},
			// Show the previous testimonial
			next: function() {
				// Remove the currently active testimonials active class
				els[activeIndex].classList.remove(visibleClass);

				// If the current index is the last jump to 
				// the first or show the next index
				if (activeIndex === els.length - 1) {
					activeIndex = 0;
				} else {
					activeIndex++
				}

				// Add the active class to the next index
				els[activeIndex].classList.add(visibleClass);
			}
		};

		prev[0].addEventListener('click', fn.prev);
		next[0].addEventListener('click', fn.next);

		// Show the first testimonial and hide the rest
		els[0].classList.add(visibleClass);
	}

	function InitCarousels()
	{
		var carousels = _doc.querySelectorAll('[data-ref="carousel"]');

		// If there's no carousels to control, return
		if (! carousels.length) {
			return;
		}

		var animatingClass = '-is-animating';
		var dragOffset;
		var dragStart;
		var dragging;

		var fn = {
			stopAnimation: function(e) {
				var el = e.currentTarget;

				// Switch from animated to scrollable
				if (el.classList.contains(animatingClass)) {
					var pageLeft = _doc.querySelectorAll('[data-ref="page"]')[0]
						.getBoundingClientRect()
						.left;
					var carouselLeft = el.getBoundingClientRect().left;

					// Toggle the animating and scrollable classes
					el.classList.remove(animatingClass);
					el.classList.add('-is-scrollable');

					// Set the scroll offset equal to the animation offset
					el.scrollLeft = (carouselLeft - pageLeft) * -1;

					// Remove the touch start event to prevent calling
					// this method more than once on mobile
					el.removeEventListener('touchstart', fn.stopAnimation)
				}
			},
			dragStart: function(e) {
				e.preventDefault();
				e.stopPropagation();

				fn.stopAnimation(e);

				var el = e.currentTarget;

				// Capture the starting carousel and mouse offset positions
				dragOffset = el.scrollLeft;
				dragStart = e.pageX - el.offsetLeft;

				dragging = true;
			},
			dragMove: function(e) {
				e.preventDefault();

				// If the user isn't currently dragging, return
				if (! dragging) {
					return;
				}

				var walk = ((e.pageX - this.offsetLeft) - dragStart) * 2; 

				this.scrollLeft = dragOffset - walk;
			},
			dragStop: function(e) {
				// If the user hasn't started dragging yet, return
				if (typeof dragging === 'undefined') {
					return;
				}

				dragging = false;
			}
		};

		// https://stackoverflow.com/a/38118591
		for (var i = 0; i < carousels.length; i++) {
			var length = carousels[i].offsetWidth;
			var duration = length / 100;

			carousels[i].style.animationDuration = duration + "s";
			carousels[i].classList.add(animatingClass);

			// For mobile, stop the animation and use native scrolling
			carousels[i].addEventListener('touchstart', fn.stopAnimation);

			carousels[i].addEventListener('mousedown', fn.dragStart);
			carousels[i].addEventListener('mousemove', fn.dragMove);
			carousels[i].addEventListener('mouseup', fn.dragStop);
			carousels[i].addEventListener('mouseleave', fn.dragStop);
		}
	}

	// Initialize custom Splide JS sliders
	function InitSliders()
	{
		var pagination = _doc.querySelectorAll('[data-ref="slider-pagination"]');
		var bullets = _doc.querySelectorAll('[data-ref="slider-bullet"]');
		var slides = _doc.querySelectorAll('[data-ref="slider-slides"]');

		// If there's no bullets or slides to control, return
		if (! bullets.length || ! slides.length) {
			return;
		}

		var sliderPrev = _doc.querySelectorAll('[data-ref="slider-prev"]')[0];
		var sliderNext = _doc.querySelectorAll('[data-ref="slider-next"]')[0];
		var breakpoint = Breakpoint();
		var activeIndex = 0;
		var resizeTimer;

		var handle = {
			// Update splide sliders for mobile, tablet, and
			// desktop based on the current breakpoint
			resizeEvent: function() {
				// Debounce resize events
				// https://css-tricks.com/snippets/jquery/done-resizing-event/
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(function() {
					breakpoint = Breakpoint();
					fn.updateBulletCount();
				}, 100);
			}
		};

		var fn = {
			// Update the number of visible bullets
			// https://splidejs.com/apis/
			updateBulletCount: function() {
				switch (breakpoint) {
					case 1:
					case 2:
						paginationSlider.options = {
							perPage: bullets.length <= 3 ? bullets.length : 3
						};
						slidesSlider.options = { gap: '0' };
						break;
					case 3:
						paginationSlider.options = {
							perPage: bullets.length <= 5 ? bullets.length : 5
						};
						slidesSlider.options = { gap: '0' };
						break;
					default:
						paginationSlider.options = {
							perPage: bullets.length <= 6 ? bullets.length : 6,
							focus: 0,
						};
						slidesSlider.options = { gap: '5%' };
						break;
				}
			},
			// Navigate to the previous slide unless
			// the first slide is active
			prev: function() {
				if (activeIndex === 0) {
					return;
				}

				activeIndex -= 1;

				paginationSlider.go(activeIndex);
				slidesSlider.go(activeIndex);
			},
			// Navigate to the next slide unless
			// the last slide is active
			next: function() {
				if (activeIndex === bullets.length) {
					return;
				}

				activeIndex += 1;

				paginationSlider.go(activeIndex);
				slidesSlider.go(activeIndex);
			}
		};

		// Initialize pagination slider
		// https://splidejs.com/guides/options/
		var paginationSlider = new Splide(pagination[0], {
			isNavigation: true,
			pagination: false,
			arrows: false,
			trimSpace: true,
			focus: 'center',
			drag: false,
			perPage: 3
		}).mount();

		paginationSlider.on('click', function(slide) {
			paginationSlider.go(slide.index);
		})
		paginationSlider.on('move', function(index) {
			activeIndex = index;
		});

		// Initialize slides slider
		// https://splidejs.com/guides/options/
		var slidesSlider = new Splide(slides[0], {
			pagination: false,
			arrows: false,
			gap: '0'
		})
		.sync(paginationSlider)
		.mount();

		slidesSlider.on('mount', fn.updateBulletCount());
		slidesSlider.on('move', function(index) {
			activeIndex = index;
		});

		// Listen from previous and next pagination click events
		sliderPrev.addEventListener('click', fn.prev);
		sliderNext.addEventListener('click', fn.next);

		_win.addEventListener('resize', handle.resizeEvent, true);
	}

	function InitVideoModals()
	{
		var links = _doc.querySelectorAll('[data-ref="video-link"]');

		// If there are no video links to control, return
		if (! links.length) {
			return;
		}

		// Create a modal if one doesn't already exist
		InitModal();

		// Create cloneable iframe embed element
		var $embed = _doc.createElement('iframe');

		$embed.setAttribute('src', '');
		$embed.setAttribute('width', '1280px');
		$embed.setAttribute('height', '720px');
		$embed.setAttribute('frameborder', '0');
		$embed.setAttribute('allow', 'autoplay; fullscreen');
		$embed.setAttribute('allowFullScreen', '');

		$embed.classList.add('video');

		var fn = {
			show: function(e) {
				var link = e.currentTarget;

				// Clone the embed element and add the current links src
				var $iframe = $embed.cloneNode(true);
				var src = link.dataset.src;

				$iframe.src = src + (src.indexOf('?') !== -1 ? '&' : '?') + 'autoplay=1';

				EB.Modal.show($iframe);

				e.preventDefault();
			}
		}

		// Add link event listeners
		for (var i = 0; i < links.length; i++) {
			links[i].addEventListener('click', fn.show);
		}
	}

	function InitModal()
	{
		// If a modal already exists, return it
		if (EB.Modal) {
			return EB.Modal;
		}

		// Create a new modal element
		var $modal = _doc.createElement('div');
		var $mask = _doc.createElement('div');
		var $content = _doc.createElement('div');
		var $close = _doc.createElement('div');

		$modal.classList.add('modal');
		$mask.classList.add('modal__mask');
		$content.classList.add('modal__content');
		$close.classList.add('modal__close');

		$modal.append($mask);
		$modal.append($content);
		$modal.append($close);

		// Add modal methods and event listeners
		var visibleClass = '-is-visible';
		var noScrollClass = '-no-scroll';
		var scrollY;

		var fn = {
			hide: function() {
				$modal.classList.remove(visibleClass);
				$content.innerHTML = '';

				_doc.body.classList.remove(noScrollClass);
				_win.scrollTo(0, scrollY);

				// Set scrollY to undefined
				// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/void
				scrollY = void 0;
			}
		}

		$close.addEventListener('click', fn.hide);

		EB.Modal = {
			show: function(content) {
				$content.append(content);
				$modal.classList.add(visibleClass);

				scrollY = _win.scrollY;

				_doc.body.classList.add(noScrollClass);
			}
		};

		_doc.body.append($modal);
	}

	// Static Page Caching / CDN / Blitz
	// https://docs.solspace.com/craft/freeform/v3/templating/caching.html#static-page-caching-cdn-blitz
	function InitForms()
	{
		var forms = _doc.querySelectorAll('[data-ref="form"]');

		// If there's no sliders to control, return
		if (! forms.length) {
			return;
		}

		var fn = {
			watch: function(form) {
				var inputs = form.querySelectorAll("[required]");

				// If there aren't any required inputs,
				// go ahead and initialize the form
				if (! inputs.length) {
					fn.init(form, '/form?handle=' + form.dataset.handle);
				}

				var input = function(e) {
					fn.init(form, '/form?handle=' + form.dataset.handle);

					for (var i = 0; i < inputs.length; i++) {
						inputs[i].removeEventListener('input', input);
					}
				};

				// Listen for input events
				for (var i = 0; i < inputs.length; i++) {
					inputs[i].addEventListener('input', input);
				}
			},
			init: function(form, url) {
				var xmlhttp = new XMLHttpRequest();

				xmlhttp.onreadystatechange = function() {
					if (xmlhttp.readyState == XMLHttpRequest.DONE) {
						if (xmlhttp.status == 200) {
							fn.update(form, xmlhttp.responseText);
						}

						// TODO: handle errors
					}
				};

				xmlhttp.open("POST", url, true);
				xmlhttp.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
				xmlhttp.setRequestHeader('Accept', 'application/json');
				xmlhttp.send();
			},
			update: function(form, data) {
				var json = JSON.parse(data);

				// Update the Form Hash
				form.querySelector('input[name=formHash]').value = json.hash;

				// Update the Form Payload
				form.querySelector('input[name=freeform_payload]').value = json.payload;

				// Update the Honeypot
				var honeypot = json.honeypot;
				var honeypotInput = form.querySelector('input[name^="' + honeypot.name.split('_')[0] + '"]');
				honeypotInput.setAttribute('id', honeypot.name);
				honeypotInput.setAttribute('name', honeypot.name);
				honeypotInput.value = honeypot.hash;

				// Locate and update the CSRF input
				var csrf = json.csrf;
				form.querySelector('input[name=' + csrf.name + ']').value = csrf.value;

				// Enable submit button(s)
				var submitButtons = form.querySelectorAll("button.form-submit[type='submit'][disabled]");
				for (var i = 0; i < submitButtons.length; i++) {
					submitButtons[i].disabled = false;
					submitButtons[i].title = '';
				}
			}
		};

		for (var i = 0; i < forms.length; i++) {
			fn.watch(forms[i]);
		}
	}

	function InitSelects()
	{
		var selects = _doc.querySelectorAll('[data-ref="select"]');
		var options = _doc.querySelectorAll('[data-ref="select-option"]');
		var activeClass = '-is-active';

		// If there are no select elements or options to control, return
		if (! selects.length || ! options.length) {
			return;
		}

		var fn = {
			toggleOptions: function(e) {
				e.currentTarget.classList.toggle(activeClass);

				// Close other active selects
				for (var i = 0; i < selects.length; i++) {
					if (selects[i] !== e.currentTarget) {
						selects[i].classList.remove(activeClass);
					}
				}

				// Prevent the hideOptions event from triggering
				// when toggling the options
				e.stopPropagation();
			},
			hideOptions: function(e) {
				// Hide all options if a click event occurs on
				// any element other than a select option
				if (e.target.dataset.ref !== 'select-option') {
					for (var i = 0; i < selects.length; i++) {
						selects[i].classList.remove(activeClass);
					}
				}
			},
			updateInput: function(e) {
				var option = e.currentTarget;
				var group = _doc.getElementsByName(option.name);
				var label = '';

				// Create a string containing values for all of the checked options
				for (var i = 0; i < group.length; i++) {
					if (group[i].dataset.label && group[i].checked) {
						label += label.length ? ', ' + group[i].dataset.label : group[i].dataset.label;
					}
				}

				// Traverse the DOM until the closest select element is found
				var el = option.parentNode;

				while (el && el.dataset.ref !== 'select') {
					el = el.parentNode;
				}

				// Set the selected options parent input value using the label value
				var input = el.querySelectorAll('[data-ref="select-input"]')[0];

				input.value = label;
			}
		}

		for (var i = 0; i < selects.length; i++) {
			selects[i].addEventListener('click', fn.toggleOptions);
		}

		for (var i = 0; i < options.length; i++) {
			options[i].addEventListener('change', fn.updateInput);
		}

		_doc.addEventListener('click', fn.hideOptions);
	}

	function InitSavingsCalculator()
	{
		var $calculatorForm = _doc.querySelectorAll('[data-ref="savings-calculator"]');

		// If the calculator is missing, return
		// before querying the require elements
		if (! $calculatorForm) {
			return;
		}

		// Shared inputs
		var $sharedCompetitorFlowCellsPerMonth = _doc.querySelectorAll('[data-ref="shared-competitor-flow-cells-per-month"]')[0];

		// Our inputs
		var $ourMachineCost = _doc.querySelectorAll('[data-ref="our-machine-cost"]')[0];
		var $ourMachineDiscount = _doc.querySelectorAll('[data-ref="our-machine-discount"]')[0];
		var $ourFlowCellCost = _doc.querySelectorAll('[data-ref="our-flow-cell-cost"]')[0];
		var $ourFlowCellDiscount = _doc.querySelectorAll('[data-ref="our-flow-cell-discount"]')[0];
		var $ourGbPerFlowCell = _doc.querySelectorAll('[data-ref="our-gb-per-flow-cell"]')[0];

		// Their inputs
		var $theirMachineCost = _doc.querySelectorAll('[data-ref="their-machine-cost"]')[0];
		var $theirMachineDiscount = _doc.querySelectorAll('[data-ref="their-machine-discount"]')[0];
		var $theirFlowCellCost = _doc.querySelectorAll('[data-ref="their-flow-cell-cost"]')[0];
		var $theirFlowCellDiscount = _doc.querySelectorAll('[data-ref="their-flow-cell-discount"]')[0];
		var $theirGbPerFlowCell = _doc.querySelectorAll('[data-ref="their-gb-per-flow-cell"]')[0];

		// Our calculated
		var $ourMachineActualCost = _doc.querySelectorAll('[data-ref="our-machine-actual-cost"]')[0];
		var $ourFlowCellActualCost = _doc.querySelectorAll('[data-ref="our-flow-cell-actual-cost"]')[0];
		var $ourFlowCellsPerMonth = _doc.querySelectorAll('[data-ref="our-flow-cells-per-month"]')[0];
		var $ourFlowCellCostPerMonth = _doc.querySelectorAll('[data-ref="our-flow-cell-cost-per-month"]')[0];

		// Their calculated
		var $theirMachineActualCost = _doc.querySelectorAll('[data-ref="their-machine-actual-cost"]')[0];
		var $theirFlowCellActualCost = _doc.querySelectorAll('[data-ref="their-flow-cell-actual-cost"]')[0];
		var $theirFlowCellsPerMonth = _doc.querySelectorAll('[data-ref="their-flow-cells-per-month"]')[0];
		var $theirFlowCellCostPerMonth = _doc.querySelectorAll('[data-ref="their-flow-cell-cost-per-month"]')[0];

		// Calculated savings
		var $yearOneCostSavings = _doc.querySelectorAll('[data-ref="year-one-cost-savings"]')[0];
		var $yearTwoCostSavings = _doc.querySelectorAll('[data-ref="year-two-cost-savings"]')[0];
		var $yearThreeCostSavings = _doc.querySelectorAll('[data-ref="year-three-cost-savings"]')[0];
		var $breakEventMonth = _doc.querySelectorAll('[data-ref="break-even-month"]')[0];

		// Calculated summary
		var $summaryBenefits = _doc.querySelectorAll('[data-ref="summary-benefits"]')[0];

		// Form actions
		var $reset = _doc.querySelectorAll('[data-ref="reset-calculator"]')[0];

		// If required elemets are missing, return
		if (
			! $sharedCompetitorFlowCellsPerMonth &&
			! $ourMachineCost &&
			! $ourMachineDiscount &&
			! $ourFlowCellCost &&
			! $ourFlowCellDiscount &&
			! $ourGbPerFlowCell &&
			! $theirMachineCost &&
			! $theirMachineDiscount &&
			! $theirFlowCellCost &&
			! $theirFlowCellDiscount &&
			! $theirGbPerFlowCell
			// TODO: Add calculated elements
		) {
			return;
		}

		// Shared calculated
		var sharedCompetitorFlowCellsPerMonth = 0;

		// Our calculated
		var ourMachineActualCost = 0;
		var ourFlowCellActualCost = 0;
		var ourFlowCellsPerMonth = 0;
		var ourFlowCellCostPerMonth = 0;

		// Their calculated
		var theirMachineActualCost = 0;
		var theirFlowCellActualCost = 0;
		var theirFlowCellsPerMonth = 0;
		var theirFlowCellCostPerMonth = 0;

		// Calculated savings
		var yearOneCostSavings = 0;
		var yearTwoCostSavings = 0;
		var yearThreeCostSavings = 0;
		var breakEventMonth = 0;

		// Calculated summary
		var summaryMachineMultiplier = 0;
		var summaryFlowCellMultiplier = 0;
		var summaryFlowCellMultiplierMonths = 0;

		// Default input type clamp values
		var clamp = {
			currency: {
				min: 1,
				max: 1e9 // 1,000,000,000 (1 Billion)
			},
			percent: {
				min: 0,
				max: 100
			},
			numeric: {
				min: 1,
				max: 1e9 // 1,000,000,000 (1 Billion)
			}
		};

		// Savings
		var savingsYears = 3;
		var savingsMonths = savingsYears * 12;

		// TODO:
		// For now, `separator`s will always be ",", and
		// the `decimalSeparator` will always be "."
		//
		// If international support is ever needed,
		// this will need to be updated
		var separator = ',';
		var decimalSeparator = '.'
		var floatPrecision = 2; // n^10, (tens, hundreds, thousands, etc.)

		var fn = {
			init: function() {
				fn.initInputs();
				fn.registerInputEvents();
				fn.calculate();
			},
			initInputs: function() {
				// Shared inputs
				$sharedCompetitorFlowCellsPerMonth.dataset.type = 'numeric';
				$sharedCompetitorFlowCellsPerMonth.dataset.default = $sharedCompetitorFlowCellsPerMonth.value;

				// Our inputs
				$ourMachineCost.dataset.type = 'currency';
				$ourMachineCost.dataset.default = $ourMachineCost.value;
				$ourMachineDiscount.dataset.type = 'percent';
				$ourMachineDiscount.dataset.default = $ourMachineDiscount.value;
				$ourFlowCellCost.dataset.type = 'currency';
				$ourFlowCellCost.dataset.default = $ourFlowCellCost.value;
				$ourFlowCellDiscount.dataset.type = 'percent';
				$ourFlowCellDiscount.dataset.default = $ourFlowCellDiscount.value;
				$ourGbPerFlowCell.dataset.type = 'numeric';
				$ourGbPerFlowCell.dataset.default = $ourGbPerFlowCell.value;

				// Their inputs
				$theirMachineCost.dataset.type = 'currency';
				$theirMachineCost.dataset.default = $theirMachineCost.value;
				$theirMachineDiscount.dataset.type = 'percent';
				$theirMachineDiscount.dataset.default = $theirMachineDiscount.value;
				$theirFlowCellCost.dataset.type = 'currency';
				$theirFlowCellCost.dataset.default = $theirFlowCellCost.value;
				$theirFlowCellDiscount.dataset.type = 'percent';
				$theirFlowCellDiscount.dataset.default = $theirFlowCellDiscount.value;
				$theirGbPerFlowCell.dataset.type = 'numeric';
				$theirGbPerFlowCell.dataset.default = $theirGbPerFlowCell.value;
			},
			registerInputEvents: function() {
				// Shared inputs
				$sharedCompetitorFlowCellsPerMonth.addEventListener('focus', handle.focus);
				$sharedCompetitorFlowCellsPerMonth.addEventListener('keydown', handle.keydown);
				$sharedCompetitorFlowCellsPerMonth.addEventListener('input', handle.input);
				$sharedCompetitorFlowCellsPerMonth.addEventListener('blur', handle.blur);

				// Our inputs
				$ourMachineCost.addEventListener('focus', handle.focus);
				$ourMachineCost.addEventListener('keydown', handle.keydown);
				$ourMachineCost.addEventListener('input', handle.input);
				$ourMachineCost.addEventListener('blur', handle.blur);

				$ourMachineDiscount.addEventListener('focus', handle.focus);
				$ourMachineDiscount.addEventListener('keydown', handle.keydown);
				$ourMachineDiscount.addEventListener('input', handle.input);
				$ourMachineDiscount.addEventListener('blur', handle.blur);

				$ourFlowCellCost.addEventListener('focus', handle.focus);
				$ourFlowCellCost.addEventListener('keydown', handle.keydown);
				$ourFlowCellCost.addEventListener('input', handle.input);
				$ourFlowCellCost.addEventListener('blur', handle.blur);

				$ourFlowCellDiscount.addEventListener('focus', handle.focus);
				$ourFlowCellDiscount.addEventListener('keydown', handle.keydown);
				$ourFlowCellDiscount.addEventListener('input', handle.input);
				$ourFlowCellDiscount.addEventListener('blur', handle.blur);

				$ourGbPerFlowCell.addEventListener('focus', handle.focus);
				$ourGbPerFlowCell.addEventListener('keydown', handle.keydown);
				$ourGbPerFlowCell.addEventListener('input', handle.input);
				$ourGbPerFlowCell.addEventListener('blur', handle.blur);

				// Their inputs
				$theirMachineCost.addEventListener('focus', handle.focus);
				$theirMachineCost.addEventListener('keydown', handle.keydown);
				$theirMachineCost.addEventListener('input', handle.input);
				$theirMachineCost.addEventListener('blur', handle.blur);

				$theirMachineDiscount.addEventListener('focus', handle.focus);
				$theirMachineDiscount.addEventListener('keydown', handle.keydown);
				$theirMachineDiscount.addEventListener('input', handle.input);
				$theirMachineDiscount.addEventListener('blur', handle.blur);

				$theirFlowCellCost.addEventListener('focus', handle.focus);
				$theirFlowCellCost.addEventListener('keydown', handle.keydown);
				$theirFlowCellCost.addEventListener('input', handle.input);
				$theirFlowCellCost.addEventListener('blur', handle.blur);

				$theirFlowCellDiscount.addEventListener('focus', handle.focus);
				$theirFlowCellDiscount.addEventListener('keydown', handle.keydown);
				$theirFlowCellDiscount.addEventListener('input', handle.input);
				$theirFlowCellDiscount.addEventListener('blur', handle.blur);

				$theirGbPerFlowCell.addEventListener('focus', handle.focus);
				$theirGbPerFlowCell.addEventListener('keydown', handle.keydown);
				$theirGbPerFlowCell.addEventListener('input', handle.input);
				$theirGbPerFlowCell.addEventListener('blur', handle.blur);

				// Form actions
				$reset.addEventListener('click', handle.reset);
			},
			calculate: function() {
				fn.calculateMachineActualPrice();
				fn.calculateFlowCellAcutalCost();
				fn.calculateFlowCellPerMonthCost();
				fn.calculateCostSavings();
				fn.calculateSummary();
			},
			calculateMachineActualPrice: function() {
				var ourMachineCost = utils.sanitize($ourMachineCost.value) * 1;
				var ourMachineDiscount = utils.sanitize($ourMachineDiscount.value) / 100;

				var theirMachineCost = utils.sanitize($theirMachineCost.value) * 1;
				var theirMachineDiscount = utils.sanitize($theirMachineDiscount.value) / 100;

				ourMachineActualCost = utils.round(ourMachineCost - (ourMachineCost * ourMachineDiscount));
				theirMachineActualCost = utils.round(theirMachineCost - (theirMachineCost * theirMachineDiscount));

				$ourMachineActualCost.innerHTML = '$' + utils.formatInputDecimalValue(ourMachineActualCost.toLocaleString());
				$theirMachineActualCost.innerHTML = '$' + utils.formatInputDecimalValue(theirMachineActualCost.toLocaleString());
			},
			calculateFlowCellAcutalCost: function() {
				var ourFlowCellCost = utils.sanitize($ourFlowCellCost.value) * 1;
				var ourFlowCellDiscount = utils.sanitize($ourFlowCellDiscount.value) / 100;

				var theirFlowCellCost = utils.sanitize($theirFlowCellCost.value) * 1;
				var theirFlowCellDiscount = utils.sanitize($theirFlowCellDiscount.value) / 100;

				ourFlowCellActualCost = utils.round(ourFlowCellCost - (ourFlowCellCost * ourFlowCellDiscount));
				theirFlowCellActualCost = utils.round(theirFlowCellCost - (theirFlowCellCost * theirFlowCellDiscount));

				$ourFlowCellActualCost.innerHTML = '$' + utils.formatInputDecimalValue(ourFlowCellActualCost.toLocaleString());
				$theirFlowCellActualCost.innerHTML = '$' + utils.formatInputDecimalValue(theirFlowCellActualCost.toLocaleString());
			},
			calculateFlowCellPerMonthCost: function() {
				sharedCompetitorFlowCellsPerMonth = utils.sanitize($sharedCompetitorFlowCellsPerMonth.value) * 1;

				var ourGbPerFlowCell = utils.sanitize($ourGbPerFlowCell.value) * 1;
				var theirGbPerFlowCell = utils.sanitize($theirGbPerFlowCell.value) * 1;

				ourFlowCellsPerMonth = Math.ceil((theirGbPerFlowCell * sharedCompetitorFlowCellsPerMonth) / ourGbPerFlowCell);
				theirFlowCellsPerMonth = Math.ceil((theirGbPerFlowCell * sharedCompetitorFlowCellsPerMonth) / theirGbPerFlowCell);

				if (! isNaN(ourFlowCellsPerMonth) && isFinite(ourFlowCellsPerMonth)) {
					$ourFlowCellsPerMonth.innerHTML = utils.formatInputDecimalValue(ourFlowCellsPerMonth.toLocaleString());
				} else {
					$ourFlowCellsPerMonth.innerHTML = '-';
				}

				if (! isNaN(theirFlowCellsPerMonth) && isFinite(theirFlowCellsPerMonth)) {
					$theirFlowCellsPerMonth.innerHTML = utils.formatInputDecimalValue(theirFlowCellsPerMonth.toLocaleString());
				} else {
					$theirFlowCellsPerMonth.innerHTML = '-';
				}

				ourFlowCellCostPerMonth = utils.round(ourFlowCellsPerMonth * ourFlowCellActualCost);
				theirFlowCellCostPerMonth = utils.round(theirFlowCellsPerMonth * theirFlowCellActualCost);

				if (! isNaN(ourFlowCellCostPerMonth) && isFinite(ourFlowCellCostPerMonth)) {
					$ourFlowCellCostPerMonth.innerHTML = '$' + utils.formatInputDecimalValue(ourFlowCellCostPerMonth.toLocaleString());
				} else {
					$ourFlowCellCostPerMonth.innerHTML = '-';
				}

				if (! isNaN(theirFlowCellCostPerMonth) && isFinite(theirFlowCellCostPerMonth)) {
					$theirFlowCellCostPerMonth.innerHTML = '$' + utils.formatInputDecimalValue(theirFlowCellCostPerMonth.toLocaleString());
				} else {
					$theirFlowCellsPerMonth.innerHTML = '-';
				}
			},
			calculateCostSavings: function() {
				var costPerMonth = [];
				var crossIndex = -1;

				costPerMonth[0] = {
					theirCost:  utils.round(theirMachineActualCost + theirFlowCellCostPerMonth),
					ourCost:  utils.round(ourMachineActualCost + ourFlowCellCostPerMonth),
				};

				for (let i = 1; i < savingsMonths; i++) {
					costPerMonth[i] = {
						ourCost: utils.round(costPerMonth[i - 1].ourCost + ourFlowCellCostPerMonth),
						theirCost: utils.round(costPerMonth[i - 1].theirCost + theirFlowCellCostPerMonth),
					};

					if (
						(costPerMonth[i - 1].ourCost > costPerMonth[i - 1].theirCost) &&
						(costPerMonth[i].ourCost < costPerMonth[i].theirCost)
					) {
						crossIndex = i;
					}
				};

				var savingsPerYear = [];

				for (var i = 0; i < savingsYears; i++) {
					var costPerMonthIndex = (12 * (i + 1)) - 1;

					savingsPerYear[i] = utils.round(costPerMonth[costPerMonthIndex].theirCost - costPerMonth[costPerMonthIndex].ourCost);
				}

				yearOneCostSavings = savingsPerYear[0];
				yearTwoCostSavings = savingsPerYear[1];
				yearThreeCostSavings = savingsPerYear[2];
				breakEventMonth = utils.clamp(crossIndex + 1, 1, false);

				var formattedYearOneCostSavings = '$' + utils.formatInputDecimalValue(yearOneCostSavings.toLocaleString());
				var formattedYearTwoCostSavings = '$' + utils.formatInputDecimalValue(yearTwoCostSavings.toLocaleString());
				var formattedYearThreeCostSavings = '$' + utils.formatInputDecimalValue(yearThreeCostSavings.toLocaleString());

				$yearOneCostSavings.innerHTML = formattedYearOneCostSavings;
				$yearOneCostSavings.setAttribute('title', formattedYearOneCostSavings);
				$yearTwoCostSavings.innerHTML = formattedYearTwoCostSavings;
				$yearTwoCostSavings.setAttribute('title', formattedYearTwoCostSavings);
				$yearThreeCostSavings.innerHTML = formattedYearThreeCostSavings;
				$yearThreeCostSavings.setAttribute('title', formattedYearThreeCostSavings);

				if (yearThreeCostSavings <= 0) {
					$breakEventMonth.innerHTML = '-';
					$breakEventMonth.setAttribute('title', '-');
				} else {
					$breakEventMonth.innerHTML = 'Month ' + breakEventMonth;
					$breakEventMonth.setAttribute('title', 'Month ' + breakEventMonth);
				}
			},
			calculateSummary: function() {
				var ourGbPerFlowCell = utils.sanitize($ourGbPerFlowCell.value) * 1;
				var theirGbPerFlowCell = utils.sanitize($theirGbPerFlowCell.value) * 1;

				summaryMachineMultiplier = Math.round((yearThreeCostSavings / ourMachineActualCost) * 10) / 10;
				summaryFlowCellMultiplier = Math.round((yearThreeCostSavings / ourFlowCellActualCost) * 10) / 10;

				if (isNaN(summaryMachineMultiplier) && ! isFinite(summaryMachineMultiplier)) {
					summaryMachineMultiplier = '-';
				}

				if (isNaN(summaryFlowCellMultiplier) && ! isFinite(summaryFlowCellMultiplier)) {
					summaryFlowCellMultiplier = '-';
				}

				summaryMachineMultiplier = utils.clamp(summaryMachineMultiplier, 0, false);
				summaryFlowCellMultiplier = utils.clamp(summaryFlowCellMultiplier, 0, false);

				var formattedSummaryMachineMultiplier = summaryMachineMultiplier.toLocaleString();
				var formattedSummaryFlowCellMultiplier = summaryFlowCellMultiplier.toLocaleString();

				var summaryBenefitsText = '';

				summaryBenefitsText += 'Bought <strong title="' + formattedSummaryMachineMultiplier + '">' + formattedSummaryMachineMultiplier + '</strong> more AVITIs, ';
				summaryBenefitsText += 'or run <strong title="' + formattedSummaryFlowCellMultiplier + '">' + formattedSummaryFlowCellMultiplier + '</strong> more flow cells by the end of year three.';

				$summaryBenefits.innerHTML = summaryBenefitsText;
			}
		};

		var handle = {
			input: function(e) {
				var pasteEvent = e.type == 'paste' ||
					(
						e.type == 'input' &&
						e.inputType &&
						e.inputType == 'insertFromPaste'
					);

				var $el = e.currentTarget;
				var updated = utils.formatInputValue($el, pasteEvent);

				$el.value = updated.value;

				$el.setSelectionRange(
					updated.cursorPosition,
					updated.cursorPosition
				);

				$el.dataset.value = $el.value;

				fn.calculate();
			},
			focus: function(e) {
				var $el = e.currentTarget;

				$el.dataset.value = $el.value;
			},
			keydown: function(e) {
				var $el = e.currentTarget;
				var allowedChars = '0123456789.-'.split('');

				allowedChars.push('Backspace');
				allowedChars.push('Delete');
				allowedChars.push('Tab');
				allowedChars.push('ArrowLeft');
				allowedChars.push('ArrowUp');
				allowedChars.push('ArrowRight');
				allowedChars.push('ArrowDown');
				allowedChars.push('PageUp');
				allowedChars.push('PageDown');

				if (! e.metaKey && allowedChars.indexOf(e.key) === -1) {
					e.preventDefault();
					e.stopPropagation();
				}

				$el.dataset.value = $el.value;
			},
			blur: function(e) {
				var $el = e.currentTarget;
				var updated = utils.formatInputValue($el, true);

				$el.value = updated.value;

				// If the input loses focus and the last character entered
				// is a a decimal, or a decimal followed by a zero,
				// return and allow them to keep typing
				var pattern = /^[\d,]+?\.0*?$/g;

				if (pattern.test($el.value)) {
					$el.value = $el.value.split(decimalSeparator)[0];
				}

				// If the value is empty, set the value
				// to zero and move the cursor to the end
				if ($el.value == '') {
					var type = $el.dataset.type;

					if (type == 'currency') {
						$el.value = 1;
					}

					if (type == 'percent') {
						$el.value = 0;
					}

					if (type == 'numeric') {
						$el.value = 1;
					}

					$el.setSelectionRange($el.value.length, $el.value.length);
					$el.dataset.value = $el.value;

					fn.calculate();

					return;
				}

				$el.value = utils.formatInputDecimalValue($el.value);
				$el.dataset.value = $el.value;

				fn.calculate();
			},
			reset: function() {
				// Shared inputs
				$sharedCompetitorFlowCellsPerMonth.value = $sharedCompetitorFlowCellsPerMonth.dataset.default;

				// Our inputs
				$ourMachineCost.value = $ourMachineCost.dataset.default;
				$ourMachineDiscount.value = $ourMachineDiscount.dataset.default;
				$ourFlowCellCost.value = $ourFlowCellCost.dataset.default;
				$ourFlowCellDiscount.value = $ourFlowCellDiscount.dataset.default;
				$ourGbPerFlowCell.value = $ourGbPerFlowCell.dataset.default;

				// Their inputs
				$theirMachineCost.value = $theirMachineCost.dataset.default;
				$theirMachineDiscount.value = $theirMachineDiscount.dataset.default;
				$theirFlowCellCost.value = $theirFlowCellCost.dataset.default;
				$theirFlowCellDiscount.value = $theirFlowCellDiscount.dataset.default;
				$theirGbPerFlowCell.value = $theirGbPerFlowCell.dataset.default;

				fn.calculate();
			}
		};

		var utils = {
			formatInputValue: function($el, pasteEvent) {
				var cursorPosition = $el.selectionStart;
				var value = $el.value;

				// TODO:
				// Validation needs to be reworked to better handle paste events
				//
				// Paste events should be bound to whole or decimal numbers
				// i.e. pasting 5.5 into 11,111.(5.5)11 should not result
				// in  111,115.51, it should result in 11,111.55

				// If the value can't be cast as a number, or the
				// user attempts to past exponent, return
				var exponentPattern = new RegExp('\\de\\d|\\d\\*\\*\\d');

				if (
					isNaN(utils.toNum(utils.sanitize(value))) ||
					exponentPattern.test(value)
				) {
					return {
						value: $el.dataset.value,
						cursorPosition: cursorPosition + ($el.dataset.value.length - value.length)
					}
				}

				// If the input event was fired because the user added a decimal
				// point, or a decimal point followed by a decimal value less
				// than or equal to the specified `floatPrecision`,
				// return and allow additional decimal values
				var pattern = new RegExp('^[\\d,]+?\\.\\d{0,' + floatPrecision + '}?$');

				if (pattern.test(value) && value.split(decimalSeparator)[1].length < floatPrecision) {
					return {
						value: value,
						cursorPosition: cursorPosition
					};
				}

				// If adding a value after a decimal, prevent
				// the event if the precision is met
				if (
					! pasteEvent &&
					! pattern.test(value) &&
					value.indexOf(decimalSeparator) > 0 &&
					cursorPosition > value.indexOf(decimalSeparator)
				) {
					return {
						value: $el.dataset.value,
						cursorPosition: cursorPosition + ($el.dataset.value.length - value.length)
					}
				}

				// Don't allow more than one decimal separator
				if (
					value.split(decimalSeparator).length > 1 &&
					value.split('')[cursorPosition - 1] == '.'
				) {
					return {
						value: value.slice(0, -1),
						cursorPosition: cursorPosition
					};
				}

				// Skip over the decimal separator when backspacing
				if ($el.dataset.value.split('')[cursorPosition] == decimalSeparator) {
					value = $el.dataset.value;
				}

				// If the input is empty or zero, return to move
				// the cursor to the end of the input value
				if (! value) {
					return {
						value: value,
						cursorPosition: cursorPosition
					};
				}

				// Sanitize the input value
				value = utils.sanitize(value);

				// Allow place values beyond the specified
				// `floatPrecision` to affect rounding
				if (! pasteEvent) {
					var roundingSplit = value.split(decimalSeparator);

					if (roundingSplit > 1) {
						// Strip precision values beyond the hundreths place
						value = roundingSplit[0] + decimalSeparator + roundingSplit
							.slice(1) // Drop the whole numbers
							.join('') // Join the decimal numbers
							.split('') // Split the decimal number
							.slice(0, floatPrecision - 1) // Drop everything after the specified float precision place value
							.join(''); // Join the decimal numbers
					}
				}

				// Convert the value to a number
				value = utils.toNum(value);

				// Clamp the input value based on the type
				var inputType = $el.dataset.type;
				var inputMin = $el.dataset.min;
				var inputMax = $el.dataset.max;

				value = utils.clamp(
					value,
					inputMin || clamp[inputType].min,
					inputMax || clamp[inputType].max
				).toLocaleString();

				if (pasteEvent) {
					cursorPosition = cursorPosition - 1;
				}

				var separatorsCount = $el.value.split(separator).length;

				// Move the cursor position forward if there are
				// fewer separators in the updated value and
				// the updated value wasn't a separator
				if (
					separatorsCount < value.split(separator).length &&
					value.split('')[cursorPosition] != separator
				) {
					cursorPosition += 1;
				}

				// Move the cursor position backwards if there are
				// more separators in the updated value
				if (separatorsCount > value.split(separator).length) {
					cursorPosition -= 1;
				}

				value = utils.formatInputDecimalValue(value);

				return {
					value: value,
					cursorPosition: cursorPosition
				};
			},
			formatInputDecimalValue: function(val) {
				// If there are fewer decimal place values than the specified
				// `floatPrecision`, append trailing zeros to satisfy
				// the float precision requirements
				var split = val.split(decimalSeparator);

				if (
					split.length > 1 &&
					split[split.length - 1].length <= floatPrecision &&
					val.slice(-1) != '0'
				) {
					return val + new Array(floatPrecision - split[split.length - 1].length + 1).join('0');
				}

				return val;
			},
			toNum: function(val) {
				if (val.indexOf(decimalSeparator) > -1) {
					return utils.toFloat(val);
				}

				return utils.toInt(val);
			},
			toInt: function(val) {
				var rounded = Math.round(val);

				return rounded < 0 ? 0 : rounded;
			},
			toFloat: function(val) {
				return utils.round(val);
			},
			round: function(val) {
				var precision = Math.pow(10, floatPrecision);

				return Math.round(val * precision) / precision;
			},
			clamp: function(num, min, max) {
				// Only clamp the min value
				if (max === false) {
					return num <= min ? min : num;
				}

				// Only clamp the max value
				if (min === false) {
					return num >= max ? max : num;
				}

				return num <= min ? min : (num >= max ? max : num);
			},
			sanitize: function(val) {
				// Strip all non numeric characters except for "." and "-"
				var sanitized = val.replace(/[^\d.-]/g, '');

				sanitized = sanitized.split(decimalSeparator);

				// Check for multiple decimal separators
				// and remove all but the first
				if (sanitized.length > 1) {
					return sanitized.slice(0, -1).join('') + decimalSeparator + sanitized.slice(-1);
				}

				return sanitized.join('');
			}
		};

		fn.init();
	}

	// Header

	function InitHeader()
	{
		var header = _doc.querySelectorAll('[data-ref="header"]');
		var headerToggle = _doc.querySelectorAll('[data-ref="header-toggle"]');
		var headerGroups = _doc.querySelectorAll('[data-ref="header-group"]');
		var headerGroupLabels = _doc.querySelectorAll('[data-ref="header-group-label"]');
		var headerSubgroups = _doc.querySelectorAll('[data-ref="header-subgroup"]');
		var headerSubgroupLabels = _doc.querySelectorAll('[data-ref="header-subgroup-label"]');
		var headerLinks = _doc.querySelectorAll('[data-ref="header-links"]');
		var scrolledClass = '-is-scrolled';
		var expandedClass = '-is-expanded';
		var breakpoint = Breakpoint();
		var isScrolled = _win.scrollY > 0;
		var isMobile = breakpoint < 4;

		var reset = {
			header: function() {
				reset.headerClasses();
				reset.headerEventListeners();
			},
			headerClasses: function() {
				header[0].classList.remove(expandedClass);

				reset.headerGroupClasses();
				reset.headerGroupLabelClasses();

				reset.headerSubgroupClasses();
				reset.headerSubgroupLabelClasses();
			},
			headerGroupClasses: function() {
				for (var i = 0; i < headerGroups.length; i++) {
					headerGroups[i].classList.remove(expandedClass);
				}
			},
			headerGroupLabelClasses: function() {
				for (var i = 0; i < headerGroupLabels.length; i++) {
					headerGroupLabels[i].classList.remove(expandedClass);
				}
			},
			headerSubgroupClasses: function() {
				for (var i = 0; i < headerSubgroups.length; i++) {
					headerSubgroups[i].classList.remove(expandedClass);
				}
			},
			headerSubgroupLabelClasses: function() {
				for (var i = 0; i < headerSubgroupLabels.length; i++) {
					headerSubgroupLabels[i].classList.remove(expandedClass);
				}
			},
			headerEventListeners: function() {
				header[0].removeEventListener('mouseleave', handle.headerMouseLeaveEvent);
				headerToggle[0].removeEventListener('click', handle.toggleEvent);

				for (var i = 0; i < headerGroupLabels.length; i++) {
					headerGroupLabels[i].removeEventListener('click', handle.groupLabelClickEvent);
					headerGroupLabels[i].removeEventListener('mouseenter', handle.groupLabelMouseEvent);
				}

				for (var i = 0; i < headerSubgroupLabels.length; i++) {
					headerSubgroupLabels[i].removeEventListener('click', handle.subgroupLabelClickEvent);
					headerSubgroupLabels[i].removeEventListener('mouseenter', handle.subgroupLabelMouseEvent);
				}
			}
		};

		var listen = {
			toggleEvent: function() {
				headerToggle[0].addEventListener('click', handle.toggleEvent);
			},
			groupLabelEventsMobile: function() {
				for (var i = 0; i < headerGroupLabels.length; i++) {
					headerGroupLabels[i].addEventListener('click', handle.groupLabelClickEvent);
				}
			},
			subgroupLabelEventsMobile: function() {
				for (var i = 0; i < headerSubgroupLabels.length; i++) {
					headerSubgroupLabels[i].addEventListener('click', handle.subgroupLabelClickEvent);
				}
			},
			groupLabelEventsDesktop: function() {
				for (var i = 0; i < headerGroupLabels.length; i++) {
					headerGroupLabels[i].addEventListener('mouseenter', handle.groupLabelMouseEvent);
				}
			},
			subgroupLabelEventsDesktop: function() {
				for (var i = 0; i < headerSubgroupLabels.length; i++) {
					headerSubgroupLabels[i].addEventListener('mouseenter', handle.subgroupLabelMouseEvent);
				}
			},
			headerMouseLeaveEventDesktop: function() {
				header[0].addEventListener('mouseleave', handle.headerMouseLeaveEvent);
			}
		};

		var handle = {
			toggleEvent: function() {
				header[0].classList.toggle(expandedClass);

				reset.headerGroupClasses();
				reset.headerSubgroupClasses();
			},
			// Toggle header labels
			groupLabelClickEvent: function() {
				var $group = document.querySelector('[data-ref="header-group"][data-id="' + this.dataset.group + '"]');

				if ($group) {
					$group.classList.toggle(expandedClass);
				}
			},
			// Toggle header sublabels
			subgroupLabelClickEvent: function() {
				var $subgroup = document.querySelector('[data-ref="header-subgroup"][data-id="' + this.dataset.subgroup + '"]');

				if ($subgroup) {
					$subgroup.classList.toggle(expandedClass);
				}
			},
			groupLabelMouseEvent: function(e) {
				reset.headerClasses();

				// Get the current group
				var $group = document.querySelector('[data-ref="header-group"][data-id="' + this.dataset.group + '"]');

				// Get the first subgroup label and subgroup
				var $subgroupLabel = $group.querySelector('[data-ref="header-subgroup-label"]');
				var $subgroup = $group.querySelector('[data-ref="header-subgroup"]');

				$subgroupLabel.classList.add(expandedClass);
				$subgroup.classList.add(expandedClass);
			},
			subgroupLabelMouseEvent: function(e) {
				reset.headerClasses();

				var $subgroupLabel = e.currentTarget;
				var $subgroup = document.querySelector('[data-ref="header-subgroup"][data-id="' + this.dataset.subgroup + '"]');

				if ($subgroup) {
					$subgroupLabel.classList.add(expandedClass);
					$subgroup.classList.add(expandedClass);
				}
			},
			headerMouseLeaveEvent: function() {
				reset.headerClasses();
			},
			resizeEvent: function() {
				breakpoint = Breakpoint();

				if (isMobile && breakpoint > 3) {
					isMobile = false;
					reset.header();
					listen.headerMouseLeaveEventDesktop();
					listen.groupLabelEventsDesktop();
					listen.subgroupLabelEventsDesktop();
					headerToggle[0].removeEventListener('click', handle.toggleEvent);
				}

				if (! isMobile && breakpoint < 4) {
					isMobile = true;
					reset.header();
					listen.toggleEvent();
					listen.groupLabelEventsMobile();
					listen.subgroupLabelEventsMobile();
				}

				utils.updateTransparency();

			},
			scrollEvent: function() {
				utils.updateTransparency();
			}
		};

		var utils = {
			updateTransparency: function() {
				isScrolled = _win.scrollY > 0;

				if (isScrolled && breakpoint > 3) {
					header[0].classList.add(scrolledClass);
				} else {
					header[0].classList.remove(scrolledClass);
				}
			}
		};

		if (isScrolled && breakpoint > 3) {
			header[0].classList.add(scrolledClass);
		}

		if (breakpoint < 4) {
			listen.toggleEvent();
			listen.groupLabelEventsMobile();
			listen.subgroupLabelEventsMobile();
		}

		if (breakpoint > 3) {
			listen.headerMouseLeaveEventDesktop();
			listen.groupLabelEventsDesktop();
			listen.subgroupLabelEventsDesktop();
		}

		_win.addEventListener('resize', handle.resizeEvent, true);
		_win.addEventListener('scroll', handle.scrollEvent, true);
	}

	function InitSubnav()
	{
		var $toggle = _doc.querySelectorAll('[data-ref="subnav-toggle"]');
		var $links = _doc.querySelectorAll('[data-ref="subnav-links"]');
		var $nav = _doc.querySelectorAll('[data-ref="subnav"]');

		// If required elemets are missing, return
		if (! $toggle.length || ! $nav.length || ! $links.length) {
			return;
		}

		var expandedClass = '-is-expanded';
		var breakpoint = Breakpoint();
		var isMobile = breakpoint < 4;

		// Reusable methods for adding sub nav event listeners
		var subscribe = {
			toggleEvent: function() {
				$toggle[0].addEventListener('click', handle.toggleEvent);
			},
			resizeEvent: function() {
				_win.addEventListener('resize', handle.resizeEvent, true);
			},
			scrollEvent: function() {
				_win.addEventListener('scroll', handle.scrollEvent, true);
			},
			clickEvent: function() {
				_doc.addEventListener('click', handle.clickEvent);
			}
		};

		// Reusable method for removing sub nav event listeners
		var unsubscribe = {
			toggleEvent: function() {
				$toggle[0].removeEventListener('click', handle.toggleEvent);
			},
			resizeEvent: function() {
				_win.removeEventListener('resize', handle.resizeEvent, true);
			},
			scrollEvent: function() {
				_win.removeEventListener('scroll', handle.scrollEvent, true);
			},
			clickEvent: function() {
				_doc.removeEventListener('click', handle.clickEvent);
			}
		};

		var handle = {
			// Toggle the sub nav on mobile and tablet
			toggleEvent: function() {
				$nav[0].classList.toggle(expandedClass);
			},
			// Update the sub nav for mobile, tablet, and
			// desktop based on the current breakpoint
			resizeEvent: function() {
				breakpoint = Breakpoint();

				// Close the sub nav when switching from
				// mobile or tablet to desktop
				if (isMobile && breakpoint > 3) {
					isMobile = false;
					$nav[0].classList.remove(expandedClass);

					unsubscribe.toggleEvent();
					unsubscribe.scrollEvent();
					unsubscribe.clickEvent();
				}

				// Add toggle event listeners for mobile and tablet
				if (! isMobile && breakpoint < 4) {
					isMobile = true;

					subscribe.toggleEvent();
					subscribe.scrollEvent();
					subscribe.clickEvent();
				}
			},
			// Close the sub nav when it's scrolled off screen
			scrollEvent: function() {
				if (
					$nav[0].classList.contains(expandedClass) &&
					$links[0].getBoundingClientRect().bottom <= 0
				) {
					$nav[0].classList.remove(expandedClass);
				}
			},
			// Close the sub nav when the any element
			// outside of the sub nav is clicked
			clickEvent: function(e) {
				var $el = e.target;

				while ($el && $el !== $nav[0]) {
					$el = $el.parentNode;
				}

				if (! $el) {
					$nav[0].classList.remove(expandedClass);
				}
			}
		};

		// Only listen for events on tablet and mobile
		if (breakpoint < 4) {
			subscribe.toggleEvent();
			subscribe.scrollEvent();
			subscribe.clickEvent();
		}

		subscribe.resizeEvent();
	}

	// Home

	function InitHeroPowerUp()
	{
		var hero = _doc.querySelectorAll('[data-ref="home-hero"]');

		// If required elemets are missing, return
		if (! hero.length) {
			return;
		}

		setTimeout(() => {
			hero[0].classList.add('-aviti-loaded');
		}, 1000);
	}

	function InitFeatureSlides()
	{
		var features = _doc.querySelectorAll('[data-ref="home-features"]');

		// If there's no timeline to control, return
		if (! features.length) {
			return;
		}

		// Initialize timeline slider
		// https://splidejs.com/guides/options/
		var featureSlider = new Splide(features[0], {
			arrows: false,
			autoplay: true,
			autoHeight: true,
			autoWidth: true,
			classes: {
				pagination: 'splide__pagination home-features__bullets',
				page: 'splide__pagination__page home-features__bullet',
			},
			interval: 5000,
			rewind: true,
			type  : 'fade'
		});
		
		featureSlider.mount();
	}

	function InitUpdateTabs()
	{
		var tabs = _doc.querySelectorAll('[data-ref="home-updates-tab"]');
		var links = _doc.querySelectorAll('[data-ref="home-updates-links"]');

		// If there are no tabs or links to control, return
		if (! tabs.length || ! links.length) {
			return;
		}

		var fn = {
			updateActiveTab: function(e) {
				// Update active tab
				for (var i = 0; i < tabs.length; i++) {
					tabs[i].classList.toggle('-is-active', tabs[i].dataset.type == e.currentTarget.dataset.type);
				}

				// Update visible links
				for (var i = 0; i < links.length; i++) {
					links[i].classList.toggle('-is-visible', links[i].dataset.type == e.currentTarget.dataset.type);
				}

				e.preventDefault();
			}
		};

		for (var i = 0; i < tabs.length; i++) {
			tabs[i].addEventListener('click', fn.updateActiveTab);
		}
	}

	// Products

	function InitAvitiFaqs()
	{
		var faqs = _doc.querySelectorAll('[data-ref="aviti-faq"]');

		// If there's no testimonials to control, return
		if (! faqs.length) {
			return;
		}

		var expandedClass = '-is-expanded';

		var fn = {
			toggle: function(e) {
				e.currentTarget.classList.toggle(expandedClass);
				e.preventDefault();
			}
		};

		for (var i = 0; i < faqs.length; i++) {
			// Delegate reset link click events
			faqs[i].addEventListener('click', function(e) {
				if (e.target.dataset.ref === 'aviti-faq-question') {
					fn.toggle(e);
				}
			});
		}
	}

	function InitVideoPlayOnHover()
	{
		var videos = _doc.querySelectorAll('[data-ref="video-play-on-hover"]');

		// If required elemets are missing, return
		if (! videos.length) {
			return;
		}

		var fn = {
			play: function(e) {
				e.currentTarget.play();
			},
			pause: function(e) {
				e.currentTarget.pause();
			}
		};

		for (var i = 0; i < videos.length; i++) {
			videos[i].addEventListener('mouseenter', fn.play);
			videos[i].addEventListener('mouseleave', fn.pause);

			videos[i].load();
		}
	}

	// Resources

	function InitResourceSearch()
	{
		var searchForm = _doc.querySelectorAll('[data-ref="resources-search"]');
		var categoryLinks = _doc.querySelectorAll('[data-resources-category]');
		var productFilters = _doc.querySelectorAll('[data-resources-product-filter]');
		var categoryFilters = _doc.querySelectorAll('[data-resources-category-filter]');

		// If required elemets are missing, return
		if (
			! searchForm.length ||
			! categoryLinks.length ||
			! productFilters.length ||
			! categoryFilters.length
		) {
			return;
		}

		var sortOrder = _doc.querySelectorAll('[data-resources-sort]');

		var data = {
			filters: {}
		};

		var fn = {
			init: function() {
				var params = _win.location.search.replace(/\?|[\[\]]/g, '').split('&');

				// Modified from:
				// https://stackoverflow.com/a/52959683/2769162
				params = params.reduce(function(filters, param) {
					var rawKeyValue = param.split('=');

					// Skip valueless params
					if (rawKeyValue.length === 1) {
						return filters;
					}

					// Decode the raw params
					var key = decodeURIComponent(rawKeyValue[0]);
					var value = decodeURIComponent(rawKeyValue[rawKeyValue.length - 1]);

					// Skip irrelevant params
					if (['category', 'product', 'keywords'].indexOf(key) === -1) {
						return filters;
					}

					// Collect array params
					if (filters[key] !== undefined) {
						// Make sure the key is an array
						if (! Array.isArray(filters[key])) {
							filters[key] = [
								filters[key]
							];
						}

						filters[key].push(value);
					} else {
						filters[key] = value;
					}

					return filters;
				}, {});

				for (var param in params) {
					// Convert all param key-values to arrays
					if (! Array.isArray(params[param])) {
						params[param] = [
							params[param]
						];
					}

					// Init the search input
					if (param === 'keywords') {
						_doc.querySelectorAll('[data-ref="resources-keywords"]')[0].value = params[param];

						fn.updateSearch();

						continue;
					}

					// Init filter inputs
					for (var i = 0; i < params[param].length; i++) {
						var filterInputs = _doc.querySelectorAll('[data-resources-' + param + '-filter="' + params[param][i] + '"]');

						for (var j = 0; j < filterInputs.length; j++) {
							var input = filterInputs[j];
							var value = input.getAttribute('data-resources-' + param + '-filter');

							input.checked = true;

							data.filters[value] = {
								label: input.dataset.label,
								value: value,
								type: param
							};
						}
					}
				}

				fn.fetch();

				if (Object.keys(params).length) {
					fn.scrollToResults('instant');
				}
			},
			setCategoryFilter: function(e) {
				var filterInputs = _doc.querySelectorAll('[data-resources-category-filter]');
				var category = e.currentTarget.dataset.resourcesCategory;

				for (var i = 0; i < filterInputs.length; i++) {
					if (filterInputs[i].value === category) {
						filterInputs[i].checked = true;

						data.filters[category] = {
							label: filterInputs[i].dataset.label,
							value: category,
							type: 'category'
						};
					} else {
						filterInputs[i].checked = false;

						delete data.filters[filterInputs[i].value];
					}
				}

				fn.fetch();
				fn.scrollToResults('smooth');
			},
			updateProductFilters: function(e) {
				fn.updateFilters(e, 'product');
			},
			updateCategoryFilters: function(e) {
				fn.updateFilters(e, 'category');
			},
			updateFilters: function(e, type) {
				var $input = e.currentTarget
				var name = $input.getAttribute('data-resources-' + type + '-filter');
				var filterInputs = _doc.querySelectorAll('[data-resources-' + type + '-filter="' + name + '"]');

				for (var i = 0; i < filterInputs.length; i++) {
					if (filterInputs[i] !== $input) {
						filterInputs[i].checked = $input.checked;
					}
				}

				if (name in data.filters) {
					delete data.filters[name];
				} else {
					data.filters[name] = {
						label: $input.dataset.label,
						value: $input.value,
						type: type
					};
				}

				fn.fetch();
			},
			removeFilter: function(e) {
				var $btn = e.currentTarget;
				var type = $btn.dataset.type;
				var value = $btn.dataset.value;

				var filterInputs = _doc.querySelectorAll('[data-resources-' + type + '-filter="' + value + '"]');

				for (var i = 0; i < filterInputs.length; i++) {
					filterInputs[i].checked = false;
				}

				delete data.filters[value];

				fn.fetch();

				$btn.removeEventListener('click', fn.removeFilter);
				$btn.remove();
			},
			resetFilters: function() {
				var filterInputs = _doc.querySelectorAll(
					'[data-resources-product-filter], [data-resources-category-filter]'
				);

				for (var i = 0; i < filterInputs.length; i++) {
					filterInputs[i].checked = false;
				}

				data.filters = {};

				fn.fetch();
			},
			updateResultFilters: function() {
				var $resultFiltersContainer = _doc.querySelectorAll('[data-ref="resources-results-filters"]')[0];

				if ($resultFiltersContainer) {
					// var sortedFilters = utils.sortObjByKey(data.filters);
					var sortedFilters = data.filters;

					$resultFiltersContainer.innerHTML = '';

					for (var key in sortedFilters) {
						var $btn = _doc.createElement('div');

						$btn.classList.add('resources-results__filter');
						$btn.setAttribute('data-type', sortedFilters[key].type);
						$btn.setAttribute('data-value', sortedFilters[key].value);
						$btn.innerHTML = sortedFilters[key].label;

						$btn.addEventListener('click', fn.removeFilter);

						$resultFiltersContainer.appendChild($btn);
					}

					var $reset = _doc.createElement('div');

					$reset.classList.add('resources-results__clear');
					$reset.innerHTML = 'Clear Filters';

					$reset.addEventListener('click', fn.resetFilters);

					$resultFiltersContainer.appendChild($reset);
				}
			},
			updatePadinationLinks: function() {
				var links = _doc.querySelectorAll('[data-ref="pagination-link"]');

				var handle = {
					click: function(e) {
						var url = e.currentTarget.href;

						fn.fetch(url);

						e.preventDefault();
					}
				};

				// Add pagination link event listeners
				for (var i = 0; i < links.length; i++) {
					links[i].addEventListener('click',handle.click);
				}
			},
			updateSortOrder: function(e) {
				data.orderBy = e.currentTarget.value;

				// Only fetch results when we have filters or keywords set
				if (! utils.objIsEmpty(data.filters) || (typeof data.keywords === 'string' && data.keywords.length > 0)) {
					fn.fetch();
				}
			},
			updateList: function(html) {
				var $resources = _doc.querySelectorAll('[data-ref="resources-resources"]')[0];

				$resources.innerHTML = html;

				$resources.classList.remove('-is-updating');

				fn.updateResultFilters();
				fn.updatePadinationLinks();

				InitResourceLinkPreviews();
			},
			updateSearch: function() {
				var $clearButton = _doc.querySelectorAll('[data-ref="resources-search-clear"]')[0];
				var $keywordsInput = _doc.querySelectorAll('[data-ref="resources-keywords"]')[0];

				data.keywords = $keywordsInput.value;

				$clearButton.addEventListener('click', fn.resetSearch);
				$clearButton.classList.add('-is-visible');
			},
			resetSearch: function() {
				var $clearButton = _doc.querySelectorAll('[data-ref="resources-search-clear"]')[0];
				var $keywordsInput = _doc.querySelectorAll('[data-ref="resources-keywords"]')[0];

				$keywordsInput.value = '';

				delete data.keywords;

				fn.fetch();

				$clearButton.classList.remove('-is-visible');
				$clearButton.removeEventListener('click', fn.resetSearch);
			},
			search: function(e) {
				fn.updateSearch();

				if (data.keywords.trim() !== '') {
					fn.fetch();
				} else {
					fn.resetSearch();
				}

				e.preventDefault();
			},
			scrollToResults: function(behavior) {
				var $resourcesContent = _doc.querySelectorAll('[data-ref="resources-content"]')[0];
				var $header = _doc.querySelectorAll('[data-ref="header"]')[0];
				var breakpoint = Breakpoint();

				_win.scrollTo({
					top: _win.pageYOffset + $resourcesContent.getBoundingClientRect().top - (breakpoint < 4 ? 0 : $header.offsetHeight),
					left: 0,
					behavior: behavior || 'auto'
				});
			},
			fetch: function(url) {
				var query = '';

				for (var filter in data.filters) {
					query += (query ? '&' : '') + data.filters[filter].type + '[]=' +  data.filters[filter].value
				}

				if (data.keywords) {
					query += (query ? '&' : '') + 'keywords=' + data.keywords;
				}

				if (data.orderBy) {
					query += (query ? '&' : '') + 'orderBy=' + data.orderBy;
				}

				var xmlhttp = new XMLHttpRequest();

				xmlhttp.onreadystatechange = function() {
					if (xmlhttp.readyState == XMLHttpRequest.DONE) {
						if (xmlhttp.status == 200) {
							// fn.update(form, xmlhttp.responseText);
							// console.log(xmlhttp.responseText);
							fn.updateList(xmlhttp.responseText);
						}

						// TODO: handle errors
					}
				};

				xmlhttp.open("POST", url || '/resources/search', true);
				xmlhttp.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
				xmlhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
				// xmlhttp.setRequestHeader('Accept', 'application/json');
				xmlhttp.send(query);

				// TODO: Show loading indicator
				// fn.updateList('Loading...');
				var $resources = _doc.querySelectorAll('[data-ref="resources-resources"]')[0];

				$resources.classList.add('-is-updating');

				$resources.innerHTML = '<div class="spinner"></div>';
			}
		};

		var utils = {
			objIsEmpty: function(obj) {
				for(var prop in obj) {
					if (obj.hasOwnProperty(prop)) {
						return false;
					}
				}

				return true;
			},
			sortObjByKey: function(obj) {
				var keys = [];
				var sorted = {};

				for (var key in obj) {
					keys.push(key);
				}

				keys.sort();

				for (var i = 0; i < keys.length; i++) {
					sorted[keys[i]] = obj[keys[i]];
				}

				return sorted;
			}
		};

		searchForm[0].addEventListener('submit', fn.search);

		for (var i = 0; i < categoryLinks.length; i++) {
			categoryLinks[i].addEventListener('click', fn.setCategoryFilter);
		}

		for (var i = 0; i < productFilters.length; i++) {
			productFilters[i].addEventListener('input', fn.updateProductFilters);
		}

		for (var i = 0; i < categoryFilters.length; i++) {
			categoryFilters[i].addEventListener('input', fn.updateCategoryFilters);
		}

		for (var i = 0; i < sortOrder.length; i++) {
			sortOrder[i].addEventListener('input', fn.updateSortOrder);
		}

		fn.init();
	}

	function InitResourceLinkPreviews()
	{
		var links = _doc.querySelectorAll('[data-ref="resources-link"]');

		var $preview = null;
		var visibleClass = '-is-visible';
		var clientX = 0;
		var clientY = 0;

		var handle = {
			mouseenter: function(e) {
				var breakpoint = Breakpoint();

				if (breakpoint < 4) {
					return;
				}

				$preview = e.currentTarget.querySelectorAll('[data-ref="resources-link-preview"]')[0];

				if ($preview) {
					$preview.classList.add(visibleClass);

					_doc.addEventListener('mousemove', handle.mousemove, true);
				}
			},
			mouseleave: function() {
				fn.reset();

				$preview = null;
			},
			mousemove: function(e) {
				if ($preview) {
					clientX = e.clientX + 2;
					clientY = e.clientY + 8;

					_win.requestAnimationFrame(fn.update);
				}
			},
			resize: function() {
				var breakpoint = Breakpoint();

				if (breakpoint < 4) {
					fn.reset();
				}
			}
		};

		var fn = {
			update: function() {
				if ($preview) {
					$preview.style.left = clientX + 'px';
					$preview.style.top = clientY + 'px';
				}
			},
			reset: function() {
				if ($preview) {
					$preview.classList.remove(visibleClass);

					clientX = 0;
					clientY = 0;

					_doc.removeEventListener('mousemove', handle.mousemove, true);
				}
			}
		};

		for (var i = 0; i < links.length; i++) {
			links[i].addEventListener('mouseenter', handle.mouseenter);
			links[i].addEventListener('mouseleave', handle.mouseleave);
		}

		// Window events
		_win.addEventListener('resize', handle.resize, true);
	}

	function InitResourceLayoutToggles()
	{
		var $content = _doc.querySelectorAll('[data-ref="resources-content"]');
		var $listToggle = _doc.querySelectorAll('[data-ref="resources-list"]');
		var $gridToggle = _doc.querySelectorAll('[data-ref="resources-grid"]');

		// If required elemets are missing, return
		if (! $content.length || ! $listToggle.length || ! $gridToggle.length) {
			return;
		}

		var activeToggleClass = '-is-active';
		var gridClass = '-grid';

		// Active layout
		var layout = 'list';

		var fn = {
			showList: function(e) {
				// Update the toggle buttons
				$gridToggle[0].classList.remove(activeToggleClass);
				$listToggle[0].classList.add(activeToggleClass);

				// Update the layout
				$content[0].classList.remove(gridClass);

				// Update the active layout
				layout = 'list';
			},
			showGrid: function() {
				// Update the toggle buttons
				$listToggle[0].classList.remove(activeToggleClass);
				$gridToggle[0].classList.add(activeToggleClass);

				// Update the layout
				$content[0].classList.add(gridClass);

				// Update the active layout
				layout = 'grid';
			}
		};

		var breakpoint = Breakpoint();

		var handle = {
			resizeEvent: function() {
				breakpoint = Breakpoint();

				// Reset the layout when transitioning
				// from desktop to mobile
				if (layout == 'grid' && breakpoint < 4) {
					fn.showList();
				}
			},
		};

		// Toggle events
		$listToggle[0].addEventListener('click', fn.showList);
		$gridToggle[0].addEventListener('click', fn.showGrid);

		// Window events
		_win.addEventListener('resize', handle.resizeEvent, true);
	}

	// Company

	// Initialize custom Splide JS company timeline slider
	function InitTimelineSlider()
	{
		var timeline = _doc.querySelectorAll('[data-ref="timeline"]');

		// If there's no timeline to control, return
		if (! timeline.length) {
			return;
		}

		// var sliderPrev = _doc.querySelectorAll('[data-ref="slider-prev"]')[0];
		// var sliderNext = _doc.querySelectorAll('[data-ref="slider-next"]')[0];
		var activeIndex = 0;

		var fn = {
			// Navigate to the previous slide unless
			// the first slide is active
			prev: function() {
				if (activeIndex === 0) {
					return;
				}

				activeIndex -= 1;

				timelineSlider.go(activeIndex);
			},
			// Navigate to the next slide unless
			// the last slide is active
			next: function() {
				if (activeIndex === bullets.length) {
					return;
				}

				activeIndex += 1;

				timelineSlider.go(activeIndex);
			}
		};

		// Initialize timeline slider
		// https://splidejs.com/guides/options/
		var timelineSlider = new Splide(timeline[0], {
			pagination: false,
			arrows: false,
			autoWidth: true,
			drag: 'free',
			gap: '0'
		})
		.mount();

		timelineSlider.on('move', function(index) {
			activeIndex = index;
		});

		// Listen from previous and next pagination click events
		// sliderPrev.addEventListener('click', fn.prev);
		// sliderNext.addEventListener('click', fn.next);
	}

	function InitOpeningFilters()
	{
		var filtersForm = _doc.querySelectorAll('[data-ref="filters"]');
		var filters = _doc.querySelectorAll('[data-ref="filter"]');
		var openings = _doc.querySelectorAll('[data-ref="openings"]');
		var reset = _doc.querySelectorAll('[data-ref="reset"]');

		// If required elemets are missing, return
		if (
			! filtersForm.length ||
			! filters.length ||
			! openings.length ||
			! reset.length
		) {
			return;
		}

		var filtered = false;

		var fn = {
			submit: function(e) {
				e.preventDefault();

				var formData = new FormData();

				filtered = false;

				// Add non-empty filters to the request
				for (var i = 0; i < filters.length; i++) {
					var value = filters[i].value.trim();

					if (value.length) {
						formData.append(filters[i].name, value);
						filtered = true;
					}
				}

				var xmlhttp = new XMLHttpRequest();

				xmlhttp.onreadystatechange = function() {
					if (xmlhttp.readyState == XMLHttpRequest.DONE) {
						if (xmlhttp.status == 200) {
							fn.update(xmlhttp.responseText);
						}

						// TODO: handle errors
					}
				};

				xmlhttp.open("POST", filtersForm[0].action, true);
				xmlhttp.setRequestHeader('X-PJAX', 'true');
				xmlhttp.send(formData);

				// Show a loading spinner
				openings[0].firstChild.innerHTML = '<div class="spinner"></div>';
			},
			update: function(data) {
				// Parse the PJAX HTML response
				// http://youmightnotneedjquery.com/#parse_html
				var html = _doc.implementation.createHTMLDocument();
				html.body.innerHTML = data;

				// Update the openings
				openings[0].innerHTML = html.querySelectorAll('[data-ref="openings"]')[0].innerHTML;

				// Toggle the reset button
				reset[0].classList.toggle('js-hide', ! filtered);
			},
			reset: function(e) {
				e.preventDefault();

				// Reset the form
				filtersForm[0].reset();

				// Trigger a form submit event
				// https://stackoverflow.com/a/44916384
				filtersForm[0].dispatchEvent(
					new Event('submit')
				);
			}
		};

		// Handle HTML form submission events
		filtersForm[0].addEventListener('submit', fn.submit);

		// Submit the form whenever a filter value changes
		for (var i = 0; i < filters.length; i++) {
			filters[i].addEventListener('change', fn.submit);
		}

		// Delegate reset link click events
		_doc.addEventListener('click', function(e) {
			if (e.target.dataset.ref === 'reset') {
				fn.reset(e);
			}
		});
	}

	return {
		Init: Init
	}
}();

var ready = function ()
{
	_doc.addEventListener('DOMContentLoaded', ready);
	App.Init();
}

_doc.readyState === 'complete' ?
	ready() : _doc.addEventListener('DOMContentLoaded', ready);